/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Col, FormGroup, Label, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'
import Select from 'react-select'

export default function SelectorBrandDelegation ({ lockedButtons, onChange, show, user, styles }) {
  let defaultValues = [{ value: '', label: `${I18n.t('dashboard_all-plural-female')}` }]
  let delegationDefault = [{ value: '', label: `${I18n.t('dashboard_all-plural-female')}` }]
  const defaultFunction = (elem) => ({ value: elem._id, label: elem.name })
  const { brands, delegations } = useSelector((state) => state)
  const [config, setConfig] = useState({})

  useEffect(() => {
    let brandsOptions = Object.values(brands).map(defaultFunction)
    let brandDefault = [{ value: '', label: `${I18n.t('dashboard_all-plural-female')}` }]
    let delegationsOptions = defaultValues

    if (user && user.brands.length > 0) {
      brandDefault = [{ value: '', label: `${I18n.t('dashboard_select')}` }].concat(brandsOptions)
      delegationsOptions = Object.values(delegations)
        .filter((item) => item.brand === brandsOptions[0].value)
        .map(defaultFunction)

      if (user.role === 'delegationManager') {
        delegationDefault = [{ value: '', label: `${I18n.t('dashboard_select')}` }]
      }
    } else {
      brandsOptions = brandDefault.concat(brandsOptions)
    }

    setConfig({
      brand: brandDefault,
      brandsOptions,
      delegation: delegationDefault,
      delegationsOptions,
    })
  }, [show])

  const handleOnChange = (data, type) => {
    let changes = {}
    if (type.name === 'brand') {
      if (data) {
        // let delegationsOptions = Object.values(delegations).filter(item => item.brand === data.value).map(defaultFunction)
        let delegationsOptions = defaultValues.concat(
          Object.values(delegations)
            .filter((item) => item.brand === data.value)
            .map(defaultFunction)
        )
        if (user && user.role === 'delegationManager') {
          delegationsOptions = Object.values(delegations)
            .filter((item) => item.brand === data.value)
            .map(defaultFunction)
          defaultValues = [{ value: '', label: `${I18n.t('dashboard_select')}` }]
        }

        changes = {
          ...config,
          brand: data,
          // delegationsOptions: defaultValues.concat(delegationsOptions),
          delegationsOptions,
          delegation: defaultValues,
        }
      } else {
        changes = { ...config, [type.name]: data, delegation: data }
      }
    } else if (type.name === 'delegation') {
      changes = { ...config, delegation: data }
    }
    onChange(changes.brand.value || null, changes.delegation.value || null)
    setConfig(changes)
  }

  return (
    <Row>
      <Col className='mb-3' xs={6}>
        <FormGroup>
          <Label for='brand'>{I18n.t('dashboard_brand')}</Label>
          <Select
            defaultValue={config.brand}
            value={config.brand}
            onChange={handleOnChange}
            options={config.brandsOptions}
            name={'brand'}
            disabled={lockedButtons}
            styles={styles}
          />
        </FormGroup>
      </Col>
      <Col className='mb-3' xs={6}>
        <FormGroup>
          <Label for='delegation'>{I18n.t('dashboard_delegation')}</Label>
          <Select
            defaultValue={config.delegation}
            value={config.delegation}
            onChange={handleOnChange}
            options={config.delegationsOptions}
            name={'delegation'}
            disabled={lockedButtons}
            styles={styles}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}
